import React from 'react'
// import PropTypes from 'prop-types'
import Contact from '../../components/Contact'
import Helmet from '../../components/seo/Helmet'

export default function ContactPage ({ helmetProps }) {
  return (
    <div>
      <Helmet {...helmetProps} />
      <h1>Kontakt oss</h1>

      <Contact who="tor" title="Vil du ta en prat om oppdrag?">
        Ta kontakt med <strong>Tor Ivar</strong> om du lurer på hva Appresso kan levere.
      </Contact>

      <Contact who="espen" title="Lurer du på noe annet?">
        Ta kontakt med <strong>Espen</strong> om du har andre spørsmål.
      </Contact>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Contact/index.js